/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProviderReferenceList } from '../models/PaginatedProviderReferenceList';
import type { PatchedProviderReferenceUpdate } from '../models/PatchedProviderReferenceUpdate';
import type { ProviderReference } from '../models/ProviderReference';
import type { ProviderReferenceCreate } from '../models/ProviderReferenceCreate';
import type { ReferenceScheduleRequest } from '../models/ReferenceScheduleRequest';
import type { ReferenceSendRequest } from '../models/ReferenceSendRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderReferencesService {

    /**
     * @returns PaginatedProviderReferenceList
     * @throws ApiError
     */
    public static providerReferencesList({
        limit,
        offset,
        provider,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        provider?: string,
    }): CancelablePromise<PaginatedProviderReferenceList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-references/',
            query: {
                'limit': limit,
                'offset': offset,
                'provider': provider,
            },
        });
    }

    /**
     * @returns ProviderReference
     * @throws ApiError
     */
    public static providerReferencesCreate({
        requestBody,
    }: {
        requestBody: ProviderReferenceCreate,
    }): CancelablePromise<ProviderReference> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-references/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderReference
     * @throws ApiError
     */
    public static providerReferencesRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this provider reference.
         */
        id: string,
    }): CancelablePromise<ProviderReference> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-references/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderReference
     * @throws ApiError
     */
    public static providerReferencesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider reference.
         */
        id: string,
        requestBody?: PatchedProviderReferenceUpdate,
    }): CancelablePromise<ProviderReference> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-references/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Render + attach the survey's response PDF (heal a missing or deleted report).
     * @returns ProviderReference
     * @throws ApiError
     */
    public static providerReferencesProcessResponseCreate({
        id,
    }: {
        /**
         * A UUID string identifying this provider reference.
         */
        id: string,
    }): CancelablePromise<ProviderReference> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-references/{id}/process-response/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Set when the survey request goes out (today sends now, else the hourly beat).
     * @returns ProviderReference
     * @throws ApiError
     */
    public static providerReferencesScheduleRequestCreate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider reference.
         */
        id: string,
        requestBody: ReferenceScheduleRequest,
    }): CancelablePromise<ProviderReference> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-references/{id}/schedule-request/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Email the survey request now (`resend` re-issues it to the current email).
     * @returns ProviderReference
     * @throws ApiError
     */
    public static providerReferencesSendRequestCreate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider reference.
         */
        id: string,
        requestBody?: ReferenceSendRequest,
    }): CancelablePromise<ProviderReference> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-references/{id}/send-request/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
